<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
         
        <!--考勤配置 -->
        <div class="container" style="width:95%;">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                
                <el-form-item   prop="deptId" label="学校切换">
                    <el-select v-model="form.deptId" placeholder="请选择学校" 
                                @change="onDeptChange">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> 
                
                <el-form-item prop="deviceId" label="宿舍设备绑定">
                    <el-select v-model="form.deviceId" clearable multiple placeholder="请选择">
                        <el-option
                            v-for="item in devices"
                            :key="item.deviceNo"
                            :label="item.deviceNo"
                            :value="item.deviceNo">
                            <span style="float: right;font-size: 13px">{{ item.deviceNo }}-{{ item.address }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="attendaceGroupId" label="宿舍考勤绑定">
                    <el-select v-model="form.attendaceGroupId" clearable placeholder="请选择">
                        <el-option
                            v-for="item in attendaceGroups"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item   prop="notReturn" label="已归">
                   <el-time-select style="width:195px;"
                        placeholder="时间"
                        v-model="form.notReturn"
                        :picker-options="{
                        start: '19:00',
                        step: '00:05',
                        end: '23:59'
                        }">
                   </el-time-select>

                   <!-- <span style="margin-left:30px;"><el-checkbox v-model="form.notReturnCheck">开启微信通知</el-checkbox></span> -->
                </el-form-item>

                <el-form-item   prop="lateReturn" label="晚归">
                   <el-time-select style="width:195px;"
                        placeholder="时间"
                        v-model="form.lateReturn"
                        :picker-options="{
                        start: '19:00',
                        step: '00:05',
                        end: '23:59'
                        }">
                   </el-time-select>

                   <!-- <span style="margin-left:30px;"><el-checkbox v-model="form.lateReturnCheck">开启微信通知</el-checkbox></span> -->
                </el-form-item>

                <!-- <el-form-item   prop="longTimeNotReturn" label="长时未归">
                    <el-time-select style="width:195px;"
                        placeholder="时间"
                        v-model="form.longTimeNotReturn"
                        :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                        }">
                   </el-time-select>
                </el-form-item> -->

                <el-form-item   prop="longTimeLateReturn" label="长时晚归">
                    <el-time-select style="width:195px;"
                        placeholder="时间"
                        v-model="form.longTimeLateReturn"
                        :picker-options="{
                        start: '20:00',
                        step: '00:05',
                        end: '23:59'
                        }">
                   </el-time-select>

                   <!-- <span style="margin-left:30px;"><el-checkbox v-model="form.longTimeLateReturnCheck">开启微信通知</el-checkbox></span> -->
                </el-form-item>

                <!-- <el-form-item   prop="notOut" label="未出">
                    <el-time-select style="width:195px;"
                        placeholder="时间"
                        v-model="form.notOut"
                        :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                        }">
                   </el-time-select>
                </el-form-item> -->

                <!-- <el-form-item   prop="longTimeNotOut" label="长时未出">
                    <el-time-select style="width:195px;"
                        placeholder="时间"
                        v-model="form.longTimeNotOut"
                        :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                        }">
                   </el-time-select>
                </el-form-item> -->

            </el-form>
            <span slot="footer" class="dialog-footer" style="text-align:right">
                <el-button type="danger" @click="clear()">清空配置</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
              
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';
    import { MessageBox } from 'element-ui';

    export default {
        name:"AttendanceConfig",
        data(){
            return{
                menuName:"",
                transferVisible:false,
                props: { multiple: true,  checkStrictly: true },
                form:{
                    deptId:"",
                    deviceId:"",
                    attendaceGroupId:"",
                    notReturn:"",
                    notReturnCheck: true,
                    lateReturn:"",
                    lateReturnCheck:true,
                    // longTimeNotReturn:"",
                    longTimeLateReturn:"",
                    longTimeLateReturnCheck:true
                    // notOut:"",
                    // longTimeNotOut:""
                },
                depts:[],
                devices:[],
                attendaceGroups:[],
                rules: {
                    // deptId: [
                    //     { required: true, message: '请选择宿舍机构绑定', trigger: 'blur' }
                    // ],
                    deviceId: [
                        { required: true, message: '请选择宿舍设备绑定', trigger: 'blur' }
                    ],
                    attendaceGroupId: [
                        { required: true, message: '请选择宿舍考勤绑定', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
            // this.getDeptCascader();
        },
        components: {
        },
        methods:{
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                        this.getDevices();
                        this.getAttendaceGroup();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 切换学校
            onDeptChange(){
                this.getData();
                this.getDevices();
                this.getAttendaceGroup();
            },
            // 获取设备
            getDevices(){
                let url  = this.listDeviceSelectUrl;
                let data = {
                    deviceTypeStr:'4',
                    commonSign:1,
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.devices = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //获取考勤组
            getAttendaceGroup(){
                let url  = this.listAttendaceGroupDataUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.attendaceGroups = res.data; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.listAttendanceConfigUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // console.log(JSON.stringify(res.data));
                        // 初始值
                        // 宿舍机构绑定
                        // this.form.deptId=(res.data.deptId_key == null?"":res.data.deptId_key);
                        
                        // 宿舍设备绑定
                        this.form.deviceId=(res.data.deviceId_key == null?"":res.data.deviceId_key.split(","));

                        //宿舍考勤绑定
                        this.form.attendaceGroupId=(res.data.attendaceGroupId_key == null?"":res.data.attendaceGroupId_key);

                        // 已归
                        this.form.notReturn=(res.data.notReturn_key == null?"":res.data.notReturn_key);

                        // 晚归
                        this.form.lateReturn=(res.data.lateReturn_key == null?"":res.data.lateReturn_key);

                        // 长时未归
                        // this.form.longTimeNotReturn=(res.data.longTimeNotReturn_key == null?"":res.data.longTimeNotReturn_key);

                        // 长时晚归
                        this.form.longTimeLateReturn=(res.data.longTimeLateReturn_key == null?"":res.data.longTimeLateReturn_key);

                        // 未出
                        // this.form.notOut=(res.data.notOut_key == null?"":res.data.notOut_key);

                        // 长时未出
                        // this.form.longTimeNotOut=(res.data.longTimeNotOut_key == null?"":res.data.longTimeNotOut_key);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        
                        let configKeyArr=new Array();
                        let configValArr=new Array();
                        
                        // 宿舍机构绑定
                        // configKeyArr.push('deptId_key');
                        // configValArr.push(this.filterCascader(this.form.deptId));
                        
                        // 宿舍设备绑定
                        configKeyArr.push('deviceId_key');
                        configValArr.push(this.form.deviceId);

                        //宿舍考勤绑定
                        configKeyArr.push('attendaceGroupId_key');
                        configValArr.push(this.form.attendaceGroupId);

                        // 已归
                        configKeyArr.push('notReturn_key');
                        configValArr.push(this.form.notReturn);

                        // configKeyArr.push('notReturn_check_key');
                        // configValArr.push(this.form.notReturnCheck?1:2);


                        // 晚归
                        configKeyArr.push('lateReturn_key');
                        configValArr.push(this.form.lateReturn);

                        // configKeyArr.push('lateReturn_check_key');
                        // configValArr.push(this.form.lateReturnCheck?1:2);

                        // 长时未归
                        // configKeyArr.push('longTimeNotReturn_key');
                        // configValArr.push(this.form.longTimeNotReturn);

                        // 长时晚归
                        configKeyArr.push('longTimeLateReturn_key');
                        configValArr.push(this.form.longTimeLateReturn);

                        // configKeyArr.push('longTimeLateReturn_check_key');
                        // configValArr.push(this.form.longTimeLateReturnCheck?1:2);

                        // 未出
                        // configKeyArr.push("notOut_key");
                        // configValArr.push(this.form.notOut);

                        // 长时未出
                        // configKeyArr.push("longTimeNotOut_key");
                        // configValArr.push(this.form.longTimeNotOut);

                        let url = this.attendanceConfigAddUrl;
                        let data = {
                            deptId:this.form.deptId,
                            configKey:configKeyArr.join(";"),
                            configVal:configValArr.join(";")
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                //this.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            this.$commonFn.showTip(err,3);
                        });

                    }
                });
            },
            // 清空配置
            clear(){
                 MessageBox.confirm('此操作将永久清空配置数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((resolve) => {
                    let url = this.attendanceConfigDelUrl;
                    let data = {
                        deptId:this.form.deptId
                    };
                    this.apiPost(url, data).then((res) => {
                        if(res.status === 200){
                            this.$commonFn.showTip(res.message,1);
                            this.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }, (err) => {
                        this.$commonFn.showTip(err,3);
                    });
                }).catch(() => {
                });
                
            },
            filterCascader(data){
                // 获取任意选项最后值
                let arrVal = new Array();
                for(var i=0; i<data.length;i++){
                    arrVal.push(data[i][data[i].length-1]);
                }
               return arrVal.join();
            },
            getName(setVal,data){
                // 角色、部门递归获取层级名称
                if(this.$util.isNotEmpty(data)){
                   let valArr = setVal.split(",");
                   var arr = new Array();
                   for(var i = 0;i < valArr.length;i++){
                       var tempArr = new Array();
                       this.recursionCascader(valArr[i], data, tempArr, data);
                       arr.push(tempArr.reverse());
                   }
                   // console.log("获取值"+JSON.stringify(arr))
                   return arr;
                }
            },
            recursionCascader(val, cdata, tempArr, data){
                if(val == 0){
                    return;
                }
                // 递归获取值
                for(var i=0; i<cdata.length;i++){
                   if(cdata[i].value == val){
                       tempArr.push(val);
                       this.recursionCascader(cdata[i].parentId, data, tempArr, data);
                   }
                   if(cdata[i].children && cdata[i].children.length) {
                       this.recursionCascader(val, cdata[i].children, tempArr, data);
                   }
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/hostel/AttendanceConfig.vue